import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ArtlistDataContext from '@/context/ArtlistDataContext';
import useStateHandler from '@/hooks/useStateHandler';
import UserService from '@/services/user.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/DeleteArtlist.css';

export default function DeleteArtlist({ open, close }) {
  const { stateHandler, cacheHandler } = useStateHandler();
  const { artlistData } = useContext(ArtlistDataContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function deleteArtlist() {
    setLoading(true);

    const { response } = await UserService.deleteArtlist(artlistData._id);

    if (response.ok) {
      stateHandler.set("temporalPopup", { 
        text: `Artlist deleted successfully!`, 
        type: "navbar-present"
      });
      cacheHandler.triggerAction("DELETE_ARTLIST");
      navigate("/profile/artlists", { replace: true });
    }
  }

  const onCloseClick = () => {
    if (!loading) {
      close();
    }
  };

  return (
    <GenericPopup open={open} className="delete-artlist-popup" opacity>
      <div className="delete-artlist-popup__container">
        <div className="delete-artlist-popup__header">
          <Text className="delete-artlist-popup__header-text">
            Delete artlist
          </Text>
          <XIcon className="delete-artlist-popup__close" onClick={onCloseClick} />
        </div>

        <Text className="delete-artlist-popup__text">
          Are you sure you want to delete this artlist?
        </Text>

        <div className="delete-artlist-popup__buttons">
          <ContinueButton
            onClick={onCloseClick}
            medium
            className="continue-button_two"
          >
            Keep it
          </ContinueButton>
          <ContinueButton
            onClick={deleteArtlist}
            medium
            className="continue-button_two"
          >
            Delete
          </ContinueButton>
        </div>
      </div>
    </GenericPopup>
  );
}
